import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
  name      : 'GeneralSlider',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {},
  mixins    : [],
  props     : {
    title: {
      type   : String,
      default: ''
    },

    items: {
      type   : Array,
      default: () => []
    },

    pagination: {
      type   : Boolean,
      default: false
    },

    buttons: {
      type   : Boolean,
      default: false
    }
  },
  enums: {},
  data() {
    return {
      swiperOption: {
        slidesPerView : 2,
        slidesPerGroup: 2,
        spaceBetween  : 20,
        loop          : true,
        autoplay      : {
          delay               : 5000,
          disableOnInteraction: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween : 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween : 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween : 10
          },
          320: {
            slidesPerView: 1,
            spaceBetween : 10
          }
        },
        pagination: {
          el       : '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
